import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface AboutUsObject {
  id: number;
  htmlAr: string;
  htmlEn: string;
  htmlKu: string;
  type: string;
}

export interface AboutUsListInfo {
  page: number;
  take: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  aboutUs: Array<AboutUsObject>;
  errors: unknown;
}

@Module
export default class AboutUsModule
  extends VuexModule
  implements AboutUsListInfo
{
  aboutUs = [] as Array<AboutUsObject>;
  page = 1;
  take = 10;
  itemCount = 0;
  pageCount = 1;
  hasPreviousPage = false;
  hasNextPage = true;
  errors = {};

  /**
   * Get about-us list
   * @returns Array<AboutUsObject>
   */
  get aboutUsList(): Array<AboutUsObject> {
    return this.aboutUs;
  }

  /**
   * Get total items
   * @returns number
   */
  get aboutUsListCount(): number {
    return this.itemCount;
  }

  @Mutation
  [Mutations.SET_ABOUT_US](data) {
    this.aboutUs = data.data;
    this.page = data.meta.page;
    this.take = data.meta.take;
    this.itemCount = data.meta.itemCount;
    this.pageCount = data.meta.pageCount;
    this.hasPreviousPage = data.meta.hasPreviousPage;
    this.hasNextPage = data.meta.hasNextPage;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ABOUT_US_CURRENT_PAGE](page) {
    this.page = page;
  }

  @Mutation
  [Mutations.RESET_ABOUT_US_LIST]() {
    this.aboutUs = [] as Array<AboutUsObject>;
    this.page = 1;
    this.take = 10;
    this.itemCount = 0;
    this.pageCount = 1;
    this.hasPreviousPage = false;
    this.hasNextPage = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_ABOUT_US_STORE]() {
    this.context.commit(Mutations.RESET_ABOUT_US_LIST);
  }

  @Action
  [Actions.DELETE_ABOUT_US](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/about-us', id)
      .then(() => {
        this.context.commit(Mutations.RESET_ABOUT_US_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.statusText],
        });
      });
  }

  @Action
  [Actions.UPDATE_ABOUT_US]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/about-us', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_ABOUT_US_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.statusText],
        });
      });
  }

  @Action
  [Actions.UPDATE_ABOUT_US_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_ABOUT_US_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_ABOUT_US_BY_ID](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/about-us', id);
  }

  @Action
  [Actions.GET_ABOUT_US]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/about-us', { params: { page: this.page } })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ABOUT_US, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.statusText],
        // });
      });
  }
}
